var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlbania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.5 5.937h-2.873c.189-.203.291-.472.285-.75A1.043 1.043 0 0012 4.61a1.044 1.044 0 00-1.913.506 1.04 1.04 0 00.293.791H7.5a1.432 1.432 0 001.44 1.388h-.045A1.387 1.387 0 0010.26 8.75c0 .24.063.474.18.682l-1.155 1.155.885.886 1.26-1.253h.15l-.75 1.717L12 13.25l1.178-1.275-.75-1.717h.15l1.26 1.252.885-.885-1.155-1.155c.117-.208.179-.443.18-.683a1.388 1.388 0 001.387-1.395h-.045a1.433 1.433 0 001.41-1.455z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbania);
export default __webpack_public_path__ + "static/media/Albania.52678b92dc53dec152986dc588f6d5a2.svg";
export { ForwardRef as ReactComponent };